import { lazyImport } from "../helpers/lazyImport";
import { MainLayout } from "../components/layouts/MainLayout";
import { Dashboard } from "../pages/Dashboard/Dashboard";
import { Profile } from "../pages/Profile/Profile";
import {UserProfile} from "../pages/Profile/UserProfile";
import { Faq } from "../pages/Faq/Faq";
import { Inspection } from "../pages/Inspector/Inspection";

import { DeficiencyReport } from "../pages/Inspector/Inspection/DeficiencyReport";
import { FieldSheet } from "../pages/Inspector/FieldSheet";
import { InspectionRequest } from "../pages/InspectionRequest";
import { InspectionDetail } from "../pages/InspectionRequest/Detail";
import { StepForm } from "../pages/Inspector/Inspection/stepForm/index";
import { InspectionForm } from "../pages/Inspector/Inspection/stepForm/InspectionForm";
import storage from "../helpers/storage";
import { Dashboard as InspectorDashboard } from "../pages/Inspector/Dashboard/Dashboard";
import { InspectionDetail as InspectorInspectionDetails } from "../pages/Inspector/Inspection/Detail";
import { Inspections } from "pages/Inspections";
import { BillsAndPayments } from "pages/BillsAndPayments";
import { DeficiencyReport as DeficiencyCustomer } from "pages/InspectionRequest/DeficiencyReport";
import { UnsatisfactoryReport } from "pages/Inspector/Inspection/DeficiencyReport/unsatisfactoryReport";
import { ContactUs } from "pages/ContactUs/ContactUs";
import { Contact } from "pages/Contact/Contact";
import { AddUser } from "pages/Users/AddUser/AddUser";


import {Users} from "pages/Users"

const { Sites } = lazyImport(() => import("../pages/Sites/routes"), "Sites");
const { Clients } = lazyImport(
  () => import("../pages/Clients/routes"),
  "Clients"
);
const basePath = process.env.REACT_APP_BASE_URL;

/**
 * Routes which can only be accessed after authentication
 * @type {{}}
 */
export const protectedCustomerRoutes = [
  {
    path: `${basePath}/app`,
    element: <MainLayout />,
    children: [
      { path: `${basePath}/app`, element: <Dashboard /> },
      { path: "sites/*", element: <Sites /> },
      { path: "clients/*", element: <Clients /> },
      { path: `${basePath}/app/dashboard`, element: <Dashboard /> },
      { path: `${basePath}/app/profile`, element: <Profile /> },
      { path: `${basePath}/app/userProfile`, element: <UserProfile /> },

      
      { path: `${basePath}/app/faq`, element: <Faq /> },
      { path: `${basePath}/app/contact`, element: <Contact /> },
      { path: `${basePath}/app/AddUser`, element: <AddUser /> },
      
      { path: `${basePath}/app/Inspector/inspection`, element: <Inspection /> },

      { path: `${basePath}/app/Inspector/fieldsheet`, element: <FieldSheet /> },
      { path: `${basePath}/app/Inspector/inspection`, element: <Inspection /> },

      {
        path: `${basePath}/app/inspection-request/:id?`,
        element: <InspectionRequest />,
      },
      {
        path: `${basePath}/app/inspection-detail/:id`,
        element: <InspectionDetail />,
      },
      {
        path: `${basePath}/app/inspection-detail/:id`,
        element: <InspectionDetail />,
      },
      {
        path: `${basePath}/app/inspections`,
        element: <Inspections />,
      },
      {
        path: `${basePath}/app/bills-and-payments`,
        element: <BillsAndPayments />,
      },

      {
        path: `${basePath}/app/deficiency-report`,
        element: <DeficiencyCustomer />,
      },
      { path: `${basePath}/app/users`, element: <Users /> },
      {
        path: `${basePath}/app/contact-us`,
        element: <ContactUs />,
      },
    ],
  },
  {
    path: `${basePath}/Inspector/inspection`,
    element: <Inspection />,
  },

  {
    path: `${basePath}/Inspector/dashboard`,
    element: <InspectorDashboard />,
  },
  {
    path: `${basePath}/Inspector/fieldsheet`,
    element: <FieldSheet />,
  },
  {
    path: `${basePath}/inspection-request`,
    element: <InspectionRequest />,
  },
  {
    path: `${basePath}/Inspector/inspection`,
    element: <Inspection />,
  },
  {
    path: `${basePath}/Inspector/fieldsheet`,
    element: <FieldSheet />,
  },
  {
    path: `${basePath}/inspection-request`,
    element: <InspectionRequest />,
  },
  {
    path: `${basePath}/app/inspection-detail/:id`,
    element: <InspectionDetail />,
  },

  {
    path: `${basePath}/Inspector/inspection`,
    element: <Inspection />,
  },
  {
    path: `${basePath}/inspection-request`,
    element: <InspectionRequest />,
  },
  {
    path: `${basePath}/inspection-detail`,
    element: <InspectionDetail />,
  },
];

export const protectedInspectorRoutes = [
  {
    path: `${basePath}/inspector`,
    element: <MainLayout />,
    children: [
      { path: `${basePath}/inspector`, element: <InspectorDashboard /> },
      {
        path: `${basePath}/inspector/dashboard`,
        element: <InspectorDashboard />,
      },
      { path: `${basePath}/inspector/profile`, element: <Profile /> },
      { path: `${basePath}/inspector/faq`, element: <Faq /> },

      {
        path: `${basePath}/inspector/inspection-detail/:id`,
        element: <InspectorInspectionDetails />,
      },

      {
        path: `${basePath}/inspector/machine-detail`,
        element: <StepForm />,
      },
      {
        path: `${basePath}/inspector/inspection-form`,
        element: <InspectionForm />,
      },
      {
        path: `${basePath}/inspector/deficiency-report`,
        element: <DeficiencyReport />,
      },
      { path: `${basePath}/inspector`, element: <InspectorDashboard /> },
      {
        path: `${basePath}/inspector/dashboard`,
        element: <InspectorDashboard />,
      },
      { path: `${basePath}/inspector/profile`, element: <Profile /> },
      { path: `${basePath}/inspector/contact`, element: <Contact /> },
      { path: `${basePath}/inspector/AddUser`, element: <AddUser /> },

      {
        path: `${basePath}/inspector/inspection-detail/:id`,
        element: <InspectorInspectionDetails />,
      },
      {
        path: `${basePath}/inspector/unsatisfactory-report`,
        element: <UnsatisfactoryReport />,
      },
    ],
  },
  {
    path: `${basePath}/app/inspection-detail/:id`,
    element: <InspectionDetail />,
  },
];

// Named Routes
export const nameBasedProtectedRoutes = {
  userDashboard: {
    name: "Dashboard",
    path: `${basePath}`,
  },
  dashborad: {
    name: "Dashboard",
    path: `${basePath}/app/dashboard`,
  },
  profile: {
    name: "Profile",
    path: `${basePath}/app/profile`,
  },
  Userprofile : {
    name: "User Profile",
    path: `${basePath}/app/userProfile`,
  },
  faq: {
    name: "Faq",
    path: `${basePath}/app/faq`,
  },
  contact: {
    name: "Contact",
    path: `${basePath}/app/Contact`,
  },
  AddUser: {
    name: "AddUser",
    path: `${basePath}/app/AddUser`,
  },
  
  newInspectionRequest: {
    name: "New Inspection Request",
    path: `${basePath}/app/inspection-request`,
  },
  inspectionDetail: {
    name: "New Inspection Request",
    path: `${basePath}/app/inspection-detail`,
  },
  inspections: {
    name: "Inspected MAchines",
    path: `${basePath}/app/inspections`,
  },
  billsAndPayments: {
    name: "Bills & Payments",
    path: `${basePath}/app/bills-and-payments`,
  },
  machineDetailForCustomer: {
    name: "Inspection",
    path: `${basePath}/app/deficiency-report`,
  },
  // Inspector routes
  iuserDashboard: {
    name: "Dashboard",
    path: `${basePath}/inspector`,
  },
  idashborad: {
    name: "Dashboard",
    path: `${basePath}/inspector/dashboard`,
  },
  iprofile: {
    name: "Profile",
    path: `${basePath}/inspector/profile`,
  },
  inspection: {
    name: "Inspection",
    path: `${basePath}/inspector/inspection`,
  },
  machineDetail: {
    name: "Inspection",
    path: `${basePath}/inspector/machine-detail`,
    element: <StepForm />,
  },
  inspectionForm: {
    name: "inspectionForm",
    path: `${basePath}/inspector/inspection-form`,
    element: <InspectionForm />,
  },
  deficiencyReport: {
    path: `${basePath}/inspector/deficiency-report`,
    element: <DeficiencyReport />,
  },
  UnsatisfactoryReport: {
    path: `${basePath}/inspector/unsatisfactory-report`,
    element: <UnsatisfactoryReport />,
  },

  iInspectionDetail: {
    name: "SR Details",
    path: `${basePath}/inspector/inspection-detail`,
  },
  users: {
    name: "Users",
    path: `${basePath}/app/users`},
  contactUs: {
    name: "Contact Us",
    path: `${basePath}/app/contact-us`,
  },
};
